import { useId } from 'react'

type LinesProps = {
  className?: string
}

export const Lines = ({ className }: LinesProps) => {
  const id1 = useId()
  const id2 = useId()
  const id3 = useId()
  const id4 = useId()
  const id5 = useId()
  const id6 = useId()
  const id7 = useId()
  const id8 = useId()
  const id9 = useId()
  const id10 = useId()
  const id11 = useId()

  return (
    <svg viewBox="0 0 350 113" fill="none" className={className}>
      <g opacity="0.8">
        <path
          d="M243.4 54.5L328.1 103.9"
          stroke={`url(#${id1})`}
        />
        <path
          d="M244.7 36.4L340.4 15.2"
          stroke={`url(#${id2})`}
        />
        <path
          d="M274.2 61.4L323.7 82.6"
          stroke={`url(#${id3})`}
        />
        <path
          d="M276.1 39.3L329.7 34.2"
          stroke={`url(#${id4})`}
        />
        <path
          d="M245.2 45.5L343.6 65.4"
          stroke={`url(#${id5})`}
        />
        <path
          d="M127.1 41.4L35.7 66.2"
          stroke={`url(#${id6})`}
        />
        <path
          d="M119.9 54.0L71.3 90.5"
          stroke={`url(#${id7})`}
        />
        <path
          d="M109.5 28.8L51.6 10.1"
          stroke={`url(#${id8})`}
        />
        <path
          d="M114.2 39.2L20.2 50.7"
          stroke={`url(#${id9})`}
        />
        <path
          d="M113.3 49.6L36.0 88.3"
          stroke={`url(#${id10})`}
        />
        <path
          d="M104.6 35.1L18.9 23.6"
          stroke={`url(#${id11})`}
        />
      </g>
      <defs>
        <linearGradient
          id={id1}
          x1="243.2"
          y1="55.0"
          x2="325.2"
          y2="102.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id2}
          x1="244.6"
          y1="35.9"
          x2="337.3"
          y2="15.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id3}
          x1="274"
          y1="61.8"
          x2="321.9"
          y2="82.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id4}
          x1="276.1"
          y1="38.8"
          x2="327.9"
          y2="33.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id5}
          x1="245.1"
          y1="45.9"
          x2="340.5"
          y2="65.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id6}
          x1="126.9"
          y1="40.9"
          x2="38.4"
          y2="65.0"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id7}
          x1="119.6"
          y1="53.6"
          x2="72.5"
          y2="88.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id8}
          x1="109.3"
          y1="29.3"
          x2="53.3"
          y2="11.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id9}
          x1="114.2"
          y1="38.7"
          x2="23.1"
          y2="49.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id10}
          x1="113.1"
          y1="49.2"
          x2="38.2"
          y2="86.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id={id11}
          x1="104.5"
          y1="35.6"
          x2="21.5"
          y2="24.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#7F7F7F" />
        </linearGradient>
      </defs>
    </svg>
  )
}
